// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import QqOutlinedSvg from "@ant-design/icons-svg/es/asn/QqOutlined";
import AntdIcon from '../components/AntdIcon';

var QqOutlined = function QqOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: QqOutlinedSvg
  }));
};

QqOutlined.displayName = 'QqOutlined';
export default React.forwardRef(QqOutlined);